<div class="loginBack-img" [style.background-image]="'url(' + loginImageSrc + ')'">
    <div class="flex h-full justify-content-center sm:justify-content-end p-fluid">
        <!-- <div class="form-wrap">
            <div style="display: flex; justify-content: center; align-items: center; height: 100vh;">
                <img src="assets/demo/images/login/login_logo.png" alt="Image" />
            </div>          
    </div> -->
</div>

<div *ngIf="(loading)" class="loading-indicator">    
    <div  class="progress-spinner">
        <div class="p-progress-spinner-svg"></div>
    </div>    
</div>


<!-- <div *ngIf="(loading)" class="loading-indicator">
    <i  class="pi pi-spin">
        <img src="../../../../../../assets/icons/propeller.png">
    </i>
</div> -->

